import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=ec2607ae&scoped=true&"
import script from "./Positions.vue?vue&type=script&lang=ts&"
export * from "./Positions.vue?vue&type=script&lang=ts&"
import style0 from "./Positions.vue?vue&type=style&index=0&id=ec2607ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2607ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBreadcrumbs,VCard,VDataTable})
